import React, { useEffect, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { AiOutlineClose } from "react-icons/ai";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "react-toastify/dist/ReactToastify.css";
import NoDataFound from "../comps/DatanotFound.png";

const FOLDER_API = `${process.env.REACT_APP_BE_MAIN_URL}/ocr/folder_create/`;
const GET_FOLDERS_API = `${process.env.REACT_APP_BE_MAIN_URL}/ocr/getfiles/`;

export default function CreateFolder() {
  const { state } = useHistory().location;

  
  const [folders, setFolders] = useState([]);
  const [folderName, setFolderName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const token = sessionStorage.getItem("userToken");
  const space = sessionStorage.getItem("space");

  // Fetch existing folders (optional)
  const fetchFolders = async () => {
    const token = sessionStorage.getItem("userToken");
    const currentSpace = sessionStorage.getItem("space");

    if (!token) {
      toast.error("Authentication token missing 😢");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.get(GET_FOLDERS_API, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const list = [...(state.state?.list || [])];

      const filteredFolders = res.data.filter(
        (folder) => folder.space_path === list.join("/")
      );
      // console.log("currentSpaceLastLevel",currentSpaceLastLevel);
      // .map((folder) => ({
      //   id: folder.id,
      //   name: folder.folder_name,
      //   path: folder.folder_path,
      //   space: folder.space_path,
      //   files: folder.files || [],
      //   createdAt: folder.created_at,
      // }));

      console.log("📂 Folders in current space:", filteredFolders);
      setFolders(filteredFolders);
    } catch (err) {
      console.error("❌ Error fetching folders:", err);
      if (err.response?.status === 401) {
        toast.error("Unauthorized! Please login again ");
      } else {
        toast.error("Failed to fetch folders ");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFolders();
  }, []);

  const handleCreateFolder = async () => {
    if (!folderName.trim()) {
      toast.warning("Please enter a valid folder name ⚠️");
      return;
    }

    const token = sessionStorage.getItem("userToken");
    if (!token) {
      toast.error("Authentication token missing 😢");
      return;
    }

    const space = sessionStorage.getItem("space");
    if (!space) {
      toast.error("No space information found 😢");
      return;
    }
    try {
      setLoading(true);
      const list = [...(state.state?.list || [])];
      const payload = {
        folder_name: folderName.trim(),
        level1: list[0] ?? null,
        level2: list[1] ?? null,
        level3: list[2] ?? null,
        level4: list[3] ?? null,
        level5: list[4] ?? null,
        level6: list[5] ?? null,
        level7: list[6] ?? null,
        level8: list[7] ?? null,
      };

      const res = await axios.post(FOLDER_API, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("✅ Folder created successfully!");

      const newFolder = {
        id: res.data.id || Date.now(),
        folder_name: res.data.folder_name,
        space: list[list.length - 1] || "",
        files: [],
      };
      setFolders((prev) => [...prev, newFolder]);
      setFolderName("");
      setShowModal(false);
    } catch (err) {
      console.error("❌ Error creating folder:", err);
      toast.error("Failed to create folder 😢");
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    history.push("/MyData1");
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
      />

      {/* Loader */}
      {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-yellow-400"></div>
        </div>
      )}

      {/* Header */}
      <header className="flex justify-between items-center p-6 border-b sticky top-0 bg-white shadow-md z-20">
        <div className="flex items-center gap-3">
          <button onClick={handleBack} className="text-2xl">
            <IoIosArrowBack />
          </button>
          <h1 className="text-xl font-semibold">Create Folder</h1>
        </div>

        <button
          onClick={() => setShowModal(true)}
          className="bg-[#FECF8B]  text-black px-6 py-2 rounded-lg font-bold"
        >
          New Folder
        </button>
      </header>

      {/* Main Content */}
      <main className="flex-1 p-6 flex flex-col items-start overflow-x-auto">
        {folders.length === 0 ? (
          <div className=" items-center m-auto">
            <img
              src={NoDataFound}
              alt="no-data"
              className="w-60 mx-auto mb-4 flex justify-center"
            />
            {/* <h2 className="text-2xl font-semibold text-gray-700 ">No Folders Found</h2> */}
          </div>
        ) : (
          <div className="grid grid-cols-10 gap-10   p-4">
            {folders.map((folder) => (
              <div
                key={folder.id}
                onClick={
                  () => {
                    let space_list = state.state.list
                    let space = space_list[space_list.length - 1]
                    history.push({
                      pathname: "/updateFile",
                      state: {
                        folderName: folder.
                          folder_name
                        , space: space,
                         list:space_list
  
                      },
                    })
                  }
                }
                // className="cursor-pointer bg-white rounded-xl shadow-md p-4 border-t-8 w-32 text-center hover:bg-gray-500 transition"
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/512/716/716784.png"
                  alt="folder"
                  className="w-12 h-12 mx-auto mb-3 "
                />
                <p className="font-semibold  text-gray-800 truncate">
                  {folder.folder_name}
                </p>
              </div>
            ))}
          </div>
        )}
      </main>

      {/* Create Folder Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div  onKeyDown={(e) => {
        if (e.key === "Enter") handleCreateFolder();
      }} className="bg-white rounded-2xl shadow-lg w-[400px] p-6 relative">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 text-gray-600 hover:text-black"
            >
              <AiOutlineClose size={20} />
            </button>
            <h2 className="text-lg font-semibold mb-4">Create Folder</h2>

            {/* Folder name input */}
            <input
              type="text"
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              placeholder="Folder Name"
              className="w-full mb-4 px-3 py-2 border rounded-md"
            />

            <button
              className="w-full bg-[#FECF8B] text-black py-2 rounded-md font-semibold"
              onClick={handleCreateFolder}
            >
              Create
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
